module.exports = __webpack_public_path__ + "static/media/TaxSaving.ee7ea1a5.png";